import axios from 'axios'
import {AuthModel} from '../models/AuthModel'

const API_URL = process.env.REACT_APP_API_ENDPOINT

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/get-user`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/auth/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/resetPassword`
export const SET_NEW_PASSWORD = `${API_URL}/setPassword`
export const VERIFY_EMAIL = `${API_URL}/verifyEmail`

// Server should return AuthModel
export function apiLogin(Email: string, Password: string) {
  return axios.post(LOGIN_URL, {email: Email, password: Password})
}

// Server should return AuthModel
export function apiRegister(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  changepassword: string
) {
  return axios.post<AuthModel>(REGISTER_URL, {
    email,
    firstname,
    lastname,
    password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function apiRequestPassword(email: string) {
  // const url = `${REQUEST_PASSWORD_URL}?email=${encodeURI(email)}`
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {email})
}

export function apiRequestSetPassword(data: any) {
  return axios.post<{result: boolean}>(SET_NEW_PASSWORD, data)
}

export function apiVerifyEmail(data: any) {
  return axios.post(VERIFY_EMAIL, data)
}
